export default "__VITE_ASSET__$lezRQA9__"